import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IPlaceholderRule } from '~/types/template'
import type { ITranslationKeyValue } from '~/types/translation'

import Tooltip from '~/components/Tooltip'
import { getTranslationErrors } from '~/utils/page-container'

interface Props {
  rules?: IPlaceholderRule[]
  translation: ITranslationKeyValue
}

const WarningTooltip = ({ rules, translation }: Props): ReactElement | null => {
  const errors = getTranslationErrors({ rules, translation })

  if (!errors) {
    return null
  }

  const {
    maxLength: { errors: maxLengthErrors, value: maxLength },
    minLength: { errors: minLengthErrors, value: minLength },
  } = errors

  const maxLengthWarning = maxLengthErrors.map(([locale, length]) => (
    <li key={`${locale}-${length}`}>{`${locale}  (${length})`}</li>
  ))

  const minLengthWarning = minLengthErrors.map(([locale, length]) => (
    <li key={`${locale}-${length}`}>{`${locale}  (${length})`}</li>
  ))

  const warningMessage =
    !!maxLengthWarning.length || !!minLengthWarning.length ? (
      <>
        {!!maxLengthWarning.length && (
          <div>
            Max-length ({maxLength}) exceeded for: <ul>{maxLengthWarning}</ul>
          </div>
        )}
        {!!minLengthWarning.length && (
          <>
            <br />
            <div>
              Min-length ({minLength}) not met for: <ul>{minLengthWarning}</ul>
            </div>
          </>
        )}
      </>
    ) : null

  return warningMessage ? (
    <Tooltip
      align={{ points: ['bl', 'tl'] }}
      mouseEnterDelay={0.2}
      overlay={warningMessage}
      placement="topRight"
      trigger={['hover']}
    >
      <div className="warning-tooltip-component">
        <MdInfoOutline color="#ca3423" size={16} />
      </div>
    </Tooltip>
  ) : null
}

export default WarningTooltip
